import React from "react";
import Icon1 from '../Fitnessimg/icon-1.png';
import Icon2 from '../Fitnessimg/icon-2.png';
import Icon3 from '../Fitnessimg/icon-3.png';
import Icon4 from '../Fitnessimg/icon-4.png';
import Icon5 from '../Fitnessimg/icon-5.png';
import Icon6 from '../Fitnessimg/icon-6.png';
import Img from '../Fitnessimg/testimonial-3.jpg';

const Courses = () => {
    return (
        <div class="container-fluid courses overflow-hidden py-5">
            <div class="container py-5">
                <div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: "800px"}}>
                    <h4 class="text-primary">Collaboration Rates</h4>
                    <h1 class="display-4 text-white mb-4">Brand Partnership Packages</h1>
                    <p class="text-white mb-0">Transparent pricing for sponsored content and long-term partnerships. All packages include creative development, posting, and basic analytics reporting.</p>
                </div>
                <div class="row gy-4 gx-0 justify-content-center">
                    {/* Instagram Post Package */}
                    <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
                        <div class="courses-item">
                            <div class="courses-item-inner p-4">
                                <div class="d-flex justify-content-between mb-4">
                                    <div class="courses-icon-img p-3">
                                        <img src={Icon1} class="img-fluid" alt="Instagram"/>
                                    </div>
                                    <div class="data-info d-flex flex-column">
                                        <div class="courses-trainer d-flex align-items-center mb-1">
                                            <p class="mb-0 text-primary">Standard Rate</p>
                                        </div>
                                        <div class="courses-date">
                                            <p class="mb-0">Per Post</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#" class="d-inline-block h4 mb-3">Instagram Post</a>
                                <div class="mb-4">
                                    <p class="text-white"><strong>$850</strong> per sponsored post</p>
                                    <ul class="text-white ps-4">
                                        <li>High-quality image/video</li>
                                        <li>2 revisions included</li>
                                        <li>24-hour story support</li>
                                        <li>Basic analytics report</li>
                                    </ul>
                                </div>
                                <a href="#" class="btn btn-primary py-2 px-4"> <span>Inquire Now</span></a>
                            </div>
                        </div>
                    </div>

                    {/* Video Content Package */}
                    <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="courses-item">
                            <div class="courses-item-inner p-4">
                                <div class="d-flex justify-content-between mb-4">
                                    <div class="courses-icon-img p-3">
                                        <img src={Icon2} class="img-fluid" alt="Video"/>
                                    </div>
                                    <div class="data-info d-flex flex-column">
                                        <div class="courses-trainer d-flex align-items-center mb-1">
                                            <p class="mb-0 text-primary">Premium Rate</p>
                                        </div>
                                        <div class="courses-date">
                                            <p class="mb-0">Per Video</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#" class="d-inline-block h4 mb-3">Video Content</a>
                                <div class="mb-4">
                                    <p class="text-white"><strong>$1,500</strong> per sponsored video</p>
                                    <ul class="text-white ps-4">
                                        <li>60-90 second branded video</li>
                                        <li>Professional editing included</li>
                                        <li>Platform optimization</li>
                                        <li>Detailed performance report</li>
                                    </ul>
                                </div>
                                <a href="#" class="btn btn-primary py-2 px-4"> <span>Inquire Now</span></a>
                            </div>
                        </div>
                    </div>

                    {/* Long-Term Partnership */}
                    <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.6s">
                        <div class="courses-item">
                            <div class="courses-item-inner p-4">
                                <div class="d-flex justify-content-between mb-4">
                                    <div class="courses-icon-img p-3">
                                        <img src={Icon3} class="img-fluid" alt="Partnership"/>
                                    </div>
                                    <div class="data-info d-flex flex-column">
                                        <div class="courses-trainer d-flex align-items-center mb-1">
                                            <p class="mb-0 text-primary">Discounted Rate</p>
                                        </div>
                                        <div class="courses-date">
                                            <p class="mb-0">Monthly</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#" class="d-inline-block h4 mb-3">Long-Term Partnership</a>
                                <div class="mb-4">
                                    <p class="text-white"><strong>$3,500</strong> per month (3+ months)</p>
                                    <ul class="text-white ps-4">
                                        <li>4 posts/month</li>
                                        <li>2 stories/week</li>
                                        <li>Dedicated content strategy</li>
                                        <li>Priority support</li>
                                        <li>Comprehensive analytics</li>
                                    </ul>
                                </div>
                                <a href="#" class="btn btn-primary py-2 px-4"> <span>Inquire Now</span></a>
                            </div>
                        </div>
                    </div>

                    {/* Instagram Stories */}
                    <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
                        <div class="courses-item">
                            <div class="courses-item-inner p-4">
                                <div class="d-flex justify-content-between mb-4">
                                    <div class="courses-icon-img p-3">
                                        <img src={Icon4} class="img-fluid" alt="Stories"/>
                                    </div>
                                    <div class="data-info d-flex flex-column">
                                        <div class="courses-trainer d-flex align-items-center mb-1">
                                            <p class="mb-0 text-primary">Standard Rate</p>
                                        </div>
                                        <div class="courses-date">
                                            <p class="mb-0">Per Story</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#" class="d-inline-block h4 mb-3">Instagram Stories</a>
                                <div class="mb-4">
                                    <p class="text-white"><strong>$300</strong> per story set</p>
                                    <ul class="text-white ps-4">
                                        <li>3-5 slides per story</li>
                                        <li>Swipe-up link included</li>
                                        <li>24-hour visibility</li>
                                        <li>Basic engagement metrics</li>
                                    </ul>
                                </div>
                                <a href="#" class="btn btn-primary py-2 px-4"> <span>Inquire Now</span></a>
                            </div>
                        </div>
                    </div>

                    {/* Reels/TikTok Content */}
                    <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="courses-item">
                            <div class="courses-item-inner p-4">
                                <div class="d-flex justify-content-between mb-4">
                                    <div class="courses-icon-img p-3">
                                        <img src={Icon5} class="img-fluid" alt="Reels"/>
                                    </div>
                                    <div class="data-info d-flex flex-column">
                                        <div class="courses-trainer d-flex align-items-center mb-1">
                                            <p class="mb-0 text-primary">Premium Rate</p>
                                        </div>
                                        <div class="courses-date">
                                            <p class="mb-0">Per Video</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#" class="d-inline-block h4 mb-3">Reels/TikTok Content</a>
                                <div class="mb-4">
                                    <p class="text-white"><strong>$1,200</strong> per sponsored reel</p>
                                    <ul class="text-white ps-4">
                                        <li>Trending audio/sounds</li>
                                        <li>Platform optimization</li>
                                        <li>Hashtag strategy</li>
                                        <li>Performance analytics</li>
                                    </ul>
                                </div>
                                <a href="#" class="btn btn-primary py-2 px-4"> <span>Inquire Now</span></a>
                            </div>
                        </div>
                    </div>

                    {/* Payment Information */}
                    <div class="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.6s">
                        <div class="courses-item">
                            <div class="courses-item-inner p-4">
                                <div class="d-flex justify-content-between mb-4">
                                    <div class="courses-icon-img p-3">
                                        <img src={Icon6} class="img-fluid" alt="Payment"/>
                                    </div>
                                    <div class="data-info d-flex flex-column">
                                        <div class="courses-trainer d-flex align-items-center mb-1">
                                            <p class="mb-0 text-primary">Payment Info</p>
                                        </div>
                                        <div class="courses-date">
                                            <p class="mb-0">Terms</p>
                                        </div>
                                    </div>
                                </div>
                                <a href="#" class="d-inline-block h4 mb-3">Payment Methods</a>
                                <div class="mb-4">
                                    <ul class="text-white ps-4">
                                        <li><strong>Preferred Methods:</strong> PayPal, Wire Transfer</li>
                                        <li>50% deposit required to book</li>
                                        <li>Balance due before posting</li>
                                        <li>Invoices provided</li>
                                        <li>Taxes not included</li>
                                    </ul>
                                    <p class="text-white mt-3"><em>Custom packages available upon request</em></p>
                                </div>
                                <a href="#" class="btn btn-primary py-2 px-4"> <span>Contact Us</span></a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 text-center wow fadeInUp" data-wow-delay="0.2s">
                        <a href="#" class="btn btn-primary py-3 px-5"> <span>Request Media Kit</span></a>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Courses;